import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: "Pool owner's return",
    income: 'Estimated annual income',
    shares: 'Super Pool Rewards',
    stakeAPY: 'Self stake APY',
    commissionAPY: 'Delegation commission APY',
  },
};
